module.exports = __webpack_public_path__ + "static/media/plug.49a8138f.svg";